
import { IdeasList } from '../ideasList/ideasList.component'
import { TopEmployeesLeaderboard } from '../topEmployeesLeaderboard/topEmployeesLeaderboard'
import { TopIdeasList } from '../topIdeasList/topIdeasList'
import logo from '../../assets/images/new-logo.png'
export const LeaderBoard = () => {
    return (
        <>
            <div className="app-content content">
                <div className="content-overlay"></div>
                <div className="header-navbar-shadow">
                <img src={logo} className="d-none d-lg-block" alt="img" />
                </div>
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-12 col-lg-3">
                                <TopEmployeesLeaderboard />

                            </div>

                            <div className='col-12 col-lg-9'>
                                <TopIdeasList />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}